export const INGRID_CDN_URL = process.env.NEXT_PUBLIC_INGRID_CDN_URL
